import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import EmailConfirmationBlocker from "./EmailConfirmationBlocker";

export default function VerificarEmailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Tenta obter o usuário da sessão ativa
    supabase.auth.getUser().then(({ data: { user: u } }) => {
      if (u) {
        setUser(u);
        return;
      }
      // Se não há sessão, usa o email do estado de navegação ou pendingSignup
      const stateEmail = location.state?.email;
      const pending = localStorage.getItem("pendingSignup");
      const pendingEmail = pending ? JSON.parse(pending).email : null;
      const email = stateEmail || pendingEmail;
      if (email) {
        setUser({ email });
      } else {
        // Sem contexto suficiente — redireciona para login
        navigate("/login", { replace: true });
      }
    });
  }, [location.state, navigate]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    localStorage.removeItem("pendingSignup");
    localStorage.removeItem("pendingProfileType");
    navigate("/login", { replace: true });
  };

  if (!user) return null;

  return <EmailConfirmationBlocker user={user} onLogout={handleLogout} />;
}
